<template>
  <div>
    <div class="head">
      <div class="img">
        <img
          src="../assets/head/logo.png"
          alt=""
          @click="$router.push({ name: 'home' })"
        />
      </div>
      <div class="navigation">
        <ul>
          <li>
            <el-popover
                placement="bottom-start"
                width="800"
                style="display: flex"
                trigger="hover">
              <el-col :span="8" v-for="(item,index) in schemeList" :key="index" style="display: flex">
                <div style="display:flex;align-items: center">
                  <div
                      style="width: 36px;height: 36px;background-color: #f8f8f8;text-align: center;border-radius: 5px;align-items: center;margin: 21px 16px;position:relative">
                    <img :src="item.columnImg" alt=""
                         style="width: 36px;height: 36px;position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);cursor: pointer"
                         @click.stop="gotoDataOne(item,item.text[0])">
                  </div>
                  <div>
                    <div
                        style="font-size: 14px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #313141;line-height: 20px;cursor: pointer"
                        @click="gotoDataOne(item,item.text[0])"
                        :title.stop="item.remark != null?item.remark:item.columnText">
                      {{ item.columnText }}
                    </div>
                  </div>
                </div>
              </el-col>
              <span slot="reference" class="navigation-button"
                    @mouseenter="divINdex=1"
                    title="可信数据空间产品">可信数据空间产品</span>
              <div v-if="divINdex==1" class="radius"></div>
            </el-popover>
          </li>
          <li>
            <el-popover
                placement="bottom-start"
                width="800"
                style="display: flex"
                trigger="hover">
              <el-col :span="8" v-for="(item,index) in unmannedCluster" :key="index" style="display: flex">
                <div style="display:flex;align-items: center">
                  <div
                      style="width: 36px;height: 36px;background-color: #f8f8f8;text-align: center;border-radius: 5px;align-items: center;margin: 21px 16px;position:relative">
                    <img :src="item.columnImg" alt=""
                         style="width: 36px;height: 36px;position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);cursor: pointer"
                         @click.stop="gotoDataOne(item,item.text[0])">
                  </div>
                  <div>
                    <div
                        style="font-size: 14px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #313141;line-height: 20px;cursor: pointer"
                        @click="gotoDataOne(item,item.text[0])"
                        :title.stop="item.remark != null?item.remark:item.columnText">
                      {{ item.columnText }}
                    </div>
                  </div>
                </div>
              </el-col>
              <span slot="reference" class="navigation-button"
                    @mouseenter="divINdex=3"
                    title="异构无人集群及智能传感器系列产品">异构无人集群及智能传感器系列产品</span>
              <div v-if="divINdex==1" class="radius"></div>
            </el-popover>
          </li>
<!--          <li>
            <span class="navigation-button" @mouseenter="divINdex=2" @click="demonstration()" title="区块链产品演示">区块链产品演示</span>
            <div v-if="divINdex==2" class="radius"></div>
          </li>-->
          <li>
                    <span slot="reference" class="navigation-button" @mouseenter="divINdex=8"
                          @click="news()">新闻动态</span>
            <div v-if="divINdex==8" class="radius"></div>
          </li>
          <li>
            <span slot="reference" class="navigation-button" @mouseenter="divINdex=9" @click="aboutUs()">关于我们</span>
          </li>
          <li>
                    <span slot="reference" class="navigation-button" @mouseenter="divINdex=10"
                          @click="recruitment">加入我们</span>
            <div v-if="divINdex==10" class="radius"></div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="head">1111</div> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "mian-head",
  data() {
    return {
      schemeList: [],
      productlist: [],
      unmannedCluster: [],
      groupList:[],
      devOpsList:[],
      aboutUsList:[],
      privacyProductList:[],
      style: {},
      divINdex: 0,
      imgList: [
        { columnImg: "../assets/head/img.png" },
        { columnImg: "../assets/head/img1.png" },
        { columnImg: "../assets/head/img2.png" },
        { columnImg: "../assets/head/img3.png" },
      ],
    };
  },
  created() {
    this.getStyle();
    this.getDataList();
  },
  methods: {
    aboutUs(item,items){//关于我们
      this.$router.push({
        name: 'about',
        query: {
          item: item,
          text: item,
          time: new Date().getTime()
        }
      })
      return
      if (item == undefined) {
        item = this.aboutUsList[0].columnText
        items = this.aboutUsList[0].list[0].columnText
      } else {
        item = item.columnText
      }
      if (items == "公司简介"){
        this.$router.push({
          name: 'about',
          query: {
            item: item,
            text: items,
            time: new Date().getTime()
          }
        })
      }else{
        this.$router.push({
          name: 'scheme',
          query: {
            item: item,
            text: item,
            time: new Date().getTime()
          }
        })
      }

    },
    watchOver(item,items){
      if (item == undefined) {
        item = this.groupList[0].columnText
        items = this.groupList[0].list[0].columnText
      } else {
        item = item.columnText
      }
      // console.log(item,items)
      this.$router.push({
        name: items == "采购链接"?"purchase":"scheme",
        query: {
          item: item,
          text: items,
          time: new Date().getTime()
        }
      })
    },
    gotoDataOne(item, items) {
      if (item.columnText === '区块链解决方案') {
        let text = item.list[0].list[0].columnText
        console.log(text)
        this.$router.push({
          name: 'scheme',
          query: {
            item: item.columnText,
            text: text,
            time: new Date().getTime()
          }
        })
      } else {
        this.$router.push({
          name: 'scheme',
          query: {
            item: item.columnText,
            text: items,
            time: new Date().getTime()
          }
        })
      }
  /*    this.$router.push({
        name: 'scheme',
        query: {
          item: item.columnText,
          text: items,
          time: new Date().getTime()
        }
      })*/
    },
    gotoNewData(text) {
      this.$router.push({
        name: 'productSeries',
        query: {
          text: text,
        }
      })
    },
    getDataList() {
      /*http://article.trilliontrust.com/publish-article/app/article/zhaowulist */
      axios
        .get(
          "https://article.trilliontrust.com/publish-article/sys/column/columnList",
          {}
        )
        .then(({ data }) => {
          if (data && data.code === 0) {
            console.log(data,'data')
            for (let item of data.list) {
              if (item.columnText === "区块链产品服务") {
                this.productlist = item.list;
              } else if (item.columnText === "可信数据空间产品") {
                this.schemeList = item.list;
              } else if (item.columnText === '群智协同产品') {
                this.groupList=item.list
              }else if (item.columnText === "运维训练产品"){
                this.devOpsList=item.list
              }else if (item.columnText === "关于我们"){
                this.aboutUsList=item.list
              }else if(item.columnText === "隐私计算产品"){
                this.privacyProductList=item.list
              }else if(item.columnText === "异构无人集群及智能传感器系列产品"){
                this.unmannedCluster=item.list
              }
            }
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    privacyProduct(item,items){
      if (item.columnText == "兆易-数据隐私计算交易平台MPDT") {
        window.open("http://mpdatatrading.trilliontrust.com/#/home")
      }else{
        if (items == "产品演示"){
          window.open("http://mpdatatrading-admin.trilliontrust.com/login?redirect=%2Findex")
        }else {
          if (item == undefined) {
            item = this.privacyProductList[0].columnText
            items = this.privacyProductList[0].list[0].columnText
          } else {
            item = item.columnText
          }
          this.$router.push({
            name: "scheme",
            query: {
              item: item,
              text: items,
              time: new Date().getTime()
            }
          })
        }
      }
    },
    getStyle() {
      for (let i = 0; i < this.schemeList.length; i++) {
        for (let l = 0; l < this.schemeList[i].text.length; l++) {
          this.$set(
            this.style,
            "style" + i + l,
            "margin-right: 10px;cursor: pointer"
          );
        }
      }

      for (let i = 0; i < this.productlist.length; i++) {
        for (let l = 0; l < this.productlist[i].text.length; l++) {
          this.$set(
            this.style,
            "style" + i + l,
            "margin-right: 10px;cursor: pointer"
          );
        }
      }
    },
    mouseover(index, indexs) {
      this.style["style" + index + indexs] =
        "margin-right: 10px;cursor: pointer;color:#000";
    },
    Productservice(item, items) {
      if (typeof item === "string" || typeof  items == "string") {
        items = item
      }else {
        if (item == undefined) {
          item = this.productlist[0].columnText
          items = this.productlist[0].list[0].columnText
        } else {
          item = item.columnText
        }
      }
      this.$router.push({
        name: 'scheme',
        query: {
          item: item,
          text: items,
          time: new Date().getTime()
        }
      })
    },
    devOpsOver(item,items){
      if (item == undefined) {
        item = this.devOpsList[0].columnText
        items = this.devOpsList[0].list[0].columnText
      } else {
        item = item.columnText
      }
      // console.log(item,items)
      this.$router.push({
        name: 'scheme',
        query: {
          item: item,
          text: items,
          time: new Date().getTime()
        }
      })
    },
    mtassets(item, items) {
      if (item == undefined) {
        axios
          .get(
            "https://article.trilliontrust.com/publish-article/sys/column/byName?text=" +
              this.schemeList[0].list[0].columnText,
            {}
          )
          .then(({ data }) => {
            if (data && data.code === 0) {
              this.$router.push({
                name: "mtevidence",
                query: {
                  item: data.list[0].parentText,
                  text: data.list[0].columnText,
                  time: new Date().getTime(),
                },
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$router.push({
          name: "mtevidence",
          query: {
            item: item.columnText,
            text: items,
            time: new Date().getTime(),
          },
        });
      }
    },
    demonstration() {
      this.$router.push({
        name: "demonstration",
      });
    },
    news() {
      this.$router.push({
        name: "news",
      });
    },
    about() {
      this.$router.push({
        name: "about",
      });
    },
    recruitment() {
      this.$router.push({
        name: "recruitment",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.head {
  min-width: 100%;
  width: 100%;
  height: 78px;
  background-color: white;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 10;
  top: 0;

  .img {
    margin-left: 5%;

    img {
      width: 115px;
      height: 27px;
    }
  }

  .navigation {
    margin-left: 83px;

    ul {
      display: flex;

      li {
        position: relative;
        margin-right: 47px;
        margin-top: 0;

        .navigation-button {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #6E6D7A;
          cursor: pointer;
          text-align: center;
          width: 100%;
          display: block;
          overflow:hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow:ellipsis;

          &:hover {
            color: #313141;
          }
        }

        .radius {
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 50%;
          width: 6px;
          height: 6px;
          background: #0069fd;
        }
      }
    }
  }
}
</style>
